import { helper } from '@ember/component/helper';

export default helper(function substring([string, start, end]) {
  return string.substring(start, end);
});
